var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.asButton)?_c('button',_vm._g({class:[_vm.$style.caption, _vm.$style.button],attrs:{"type":"button"},domProps:{"innerHTML":_vm._s(_vm.caption)}},_vm.$listeners)):_c('span',_vm._g({class:_vm.$style.caption,domProps:{"innerHTML":_vm._s(_vm.caption)}},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }